<template>
  <div class="scanEffectiveContent">
    <div class="orderContent">
      <a-checkbox
        v-model:checked="submitParams.confirmed"
        @change="onChange"
        style="margin-bottom: 20px"
      >
        确定患者本次已复诊
      </a-checkbox>
      <a-form
        layout="vertical"
        v-if="submitParams.confirmed"
        :model="submitParams"
        ref="scanFormRef"
        class="retreatForm"
      >
        <a-form-item label="核销复诊依据" name="completeCureActionId" style="margin-bottom: 40px">
          <a-select
            v-model:value="submitParams.completeCureActionId"
            style="width: 100%"
            placeholder="请选择"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :options="recordCusMap.completeReserveActionRecordList"
          ></a-select>
        </a-form-item>
        <a-form-item
          v-if="
            recordCusMap.effectiveScanQueryResponseList &&
            recordCusMap.effectiveScanQueryResponseList.length
          "
          :rules="{
            required: recordCusMap.effectiveScanQueryResponseList.length,
            message: '请选择'
          }"
          label="添加扫码记录"
          name="scanId"
        >
          <a-select
            v-model:value="submitParams.scanId"
            style="width: 100%"
            placeholder="请选择"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :options="recordCusMap.effectiveScanQueryResponseList"
          ></a-select>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, defineProps, defineExpose, onMounted } from 'vue'
import useScanHooks from './useScanHooks'

const submitParams = reactive({
  confirmed: false,
  completeCureActionId: null,
  scanId: null
})

const prop = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  }
})

const { recordCusMap, getRecordDayly } = useScanHooks(prop)

onMounted(() => {
  getRecordDayly()
})

const onChange = e => {
  if (e.target.checked) {
    const { completeReserveActionRecordList, effectiveScanQueryResponseList } = recordCusMap || {}
    submitParams.completeCureActionId = completeReserveActionRecordList.length
      ? completeReserveActionRecordList[0].completeCureActionId
      : null
    submitParams.scanId = effectiveScanQueryResponseList.length
      ? effectiveScanQueryResponseList[0].scanId + ''
      : null
  }
}

const scanFormRef = ref()
const reFormRef = ref()
const submitForm = () => {
  return reFormRef.value?.submitValidQuery()
}
const mainformValid = () => {
  return new Promise((resolve, reject) => {
    scanFormRef.value
      .validate()
      .then(() => {
        const { completeCureActionId, scanId } = submitParams
        const temp1 = recordCusMap.completeReserveActionRecordList.filter(item => {
          return item.completeCureActionId === completeCureActionId
        })
        const { completeCureActionType, scanCureActionId, scanCureActionType } = temp1[0]
        resolve({
          ...submitParams,
          completeCureActionId,
          completeCureActionType,
          scanCureActionId,
          scanCureActionType,
          scanId
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}
defineExpose({
  mainformValid,
  submitForm
})
</script>
<style lang="scss" scoped>
@import './normalizeOrder.scss';
</style>
